export default __webpack_public_path__ + "static/media/green-planet.eb8b1d25.png";